// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const WarningSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M130.2 23.7c-4 1.9.9-6-71.1 115.6L0 239.1v6.7c0 6.7 0 6.7 7.5 17.9 4.6 7 8.6 11.8 10.4 12.8 2.7 1.3 18.2 1.5 132.1 1.5 113.9 0 129.4-.2 132.1-1.5 1.8-1 5.8-5.8 10.4-12.8 7.5-11.1 7.5-11.2 7.5-17.9v-6.7l-59.1-99.8C168.6 17.1 173.8 25.6 169.6 23.6c-4.9-2.3-34.6-2.3-39.4.1zm81.9 101c28.2 47.8 55.9 94.5 61.5 104l10.2 17.1-5.4 8.1-5.4 8.1H27l-5.4-8.1-5.4-8.1 7.2-12.1c3.9-6.7 31.7-53.5 61.6-104L139.4 38H160.7l51.4 86.7z" />
      <path d="M142 129.8c0 15.4.3 35.4.7 44.5l.6 16.7h13.4l.6-16.7c.4-9.1.7-29.1.7-44.5V102h-16v27.8zM140 220v10h20v-20h-20v10z" />
    </svg>
  )
}
